import type { ReactNode } from 'react';

import type { AppConfig } from '../config';

export interface LayoutProps {
  config: AppConfig;
  children: ReactNode;
}

export function Layout({ config, children }: LayoutProps) {
  return (
    <div className="app-layout">
      <header className="app-layout__header">
        <h1 className="app-layout__title">Clara</h1>
        <h2 className="app-layout__env" title="Runtime environment">
          Environment: {config.environment}
        </h2>
      </header>
      <main className="app-layout__content">{children}</main>
    </div>
  );
}
